/* eslint-disable eqeqeq */
import { useState, useEffect, useCallback, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Grid from "@mui/material/Grid";
import moment from "moment";
import useMediaQuery from "@mui/material/useMediaQuery";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import Modal from "@mui/material/Modal";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import SendIcon from "@mui/icons-material/Send";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import GridOnOutlinedIcon from "@mui/icons-material/GridOnOutlined";
import ViewTimelineOutlinedIcon from "@mui/icons-material/ViewTimelineOutlined";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
//file
// import sliderRigh from '../../Image/sliderRigh.png'
import {
  fAlertToast,
  GetGitterColumns,
  GetAccountPostingDetail,
  GetLinkDocument,
} from "../../Utility/Utilitys";
import { RoLoadingLists } from "../../Redux/roStore";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import { RpDesign_getGitterColumns_trnTyp_GETROW, WMSloading_LoadingDelete001 } from "../../Server/ApiV2";
import WmsFooter from "./processComponent/WmsFooter";
import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";
import {
  CmpButton,
  CmpButtonKIcon,
  CmpButtonKWithIcon,
} from "../../Component/Common/ToolBox/ToolBox";
import {
  //init
  ErrorMsg,
  //save
  fValidationHead_Client,
  //audit
  GridDataAuditColumns,

  //search
  sStatusArr,
  GridDataColumnsSearch,

  //customer
  xGC_Toggle_Head_Customer_DropDown_Arr,
  xGC_Toggle_Head_Customer_GridColumns_def,
  Get_ToggleDropDown_Load,
  GetLoadingListCheckbox,
  GetSIDetail,
  GetAttributes,
  AllPartyFlag,
} from "./LoadingListAction";
//NOWADDED
import { fExecuteAPI } from "./../../Server/Apis";
import { fcheck_null_undefine_replace_empty } from "./../../Utility/Utilitys";
import {
  Set_LoadingList_HeadObject_Set,
  Set_LoadingList_HeadObject_Init,
  Wms_LoadingList_HeadObject_New_Set,
  Wms_LoadingList_Footer_CBM,
  Set_LoadingList_HeadObject_A_VocNo,
  Set_LoadingList_HeadLoadingListUserCheckbox,
  Set_LoadingList_HeadObject_A_DocStat,
  Set_LoadingList_HeadLoadingListUser,
} from "./SliceLoadingList";
import GCLoadingListSearch from "./../../Component/Common/ReuseableComponent/GCLoadingListSearch";
import GCReverse from "./../../Component/Common/ReuseableComponent/GCReverse";
import "./LoadingList.css";
import { fCheck_Doc_Rights_001 } from "./../../Utility/Utilitys";
import { FShortCutKey } from "./../../Utility/Utilitys";
import GCAccountDetail from "./../../Component/Common/ReuseableComponent/GCAccountDetail";
import GCMenuBtn from "./../../Component/Common/ReuseableComponent/GCMenuBtn";
import GCLinkDocument from "./../../Component/Common/ReuseableComponent/GCLinkDocument";
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky";
import GCAuditTblCard from "../../Component/Common/ReuseableComponent/GCAuditTblCard";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import { DetailTblCard } from "./processComponent/DetailTblCard";
import GCHead from "./processComponent/GCHead";
import UpdatedTruck from "./processComponent/UpdatedTruck";
export default function LoadingList() {
  //NAV
  const [sShowMore, setShowMore] = useState(false); // nav bar arrow input value

  const vRdxDBLocation = useSelector((state) => state.SliceGRNLocation.value);

  const [sNavDocValue, setNavDocValue] = useState(1); // nav bar arrow input value
  const [sUser_Doc_Arr, setUser_Doc_Arr] = useState([]);

  const [sObjRights, setObjRights] = useState({
    RNew: "Y",
    RSave: "Y",
    RDelete: "Y",
    RApprove: "Y",
    RPrint: "Y",
    RReverse: "Y",
    RClone: "Y",
  });

  const [sObjectRights, setObjectRights] = useState({
    DocTyp: "",
    Save: "Y",
    Edit: "Y",
    Del: "Y",
    View: "Y",
    Appr: "Y",
    Reverse: "Y",
    Cancel: "Y",
    Print: "Y",
    Clone: "Y",
    Lvl: "",
  });
  const vRdxWmsHead = useSelector(
    (state) => state.SliceLoadingList.value.HeadObject
  );
  const vRdxLoadingListUserCheckbox = useSelector(
    (state) => state.SliceLoadingList.value.LoadingListUserCheckbox
  );
  const vRdxLoadingListUser = useSelector(
    (state) => state.SliceLoadingList.value.LoadingListUser
  );

  //nav end

  //spinner
  const dispatch = useDispatch();

  //spinner end
  const [
    xGC_Toggle_Head_Customer_GridColumns,
    setGC_Toggle_Head_Customer_GridColumns,
  ] = useState(xGC_Toggle_Head_Customer_GridColumns_def);
  //head
  const [sErrorMsg, setErrorMsg] = useState(ErrorMsg);
  const [sDocLoading, setDocLoading] = useState([]);
  const [sClusterArr, setClusterArr] = useState([]);
  const [sLocationArr, setLocationArr] = useState(vRdxDBLocation);
  const [sLoadingTypeArr, setLoadingTypeArr] = useState([
    "Invoicewise",
    "Consolidated",
  ]);
  const [sTransactionArr, setTransactionArr] = useState([]);
  const [sUnloadingBayArr, setUnloadingBayArr] = useState([]);
  const [sTruckArr, setTruckArr] = useState([]);

  //HEAD start
  //HEAD
  const fGrnType = async (event) => {
    var vGrnType = sDocLoading?.find((obj, index) => {
      return obj.VocTyp === event.target.value;
    });

    dispatch(
      Set_LoadingList_HeadObject_Set({
        ...vRdxWmsHead,
        A_VocTyp: vGrnType?.VocTyp,
        A_VocTypName: vGrnType?.VocName,
      })
    );
  };

  const fCluster = async (event) => {
    dispatch(
      Set_LoadingList_HeadObject_Set({
        ...vRdxWmsHead,
        Cluster: event.target.value,
      })
    );
  };

  const fLocation = async (e) => {
    dispatch(
      Set_LoadingList_HeadObject_Set({
        ...vRdxWmsHead,
        A_Loc: e.target.value,
      })
    );
  };
  const fLoadingType = async (e) => {
    dispatch(
      Set_LoadingList_HeadObject_Set({
        ...vRdxWmsHead,
        A_Type: e.target.value,
      })
    );
  };
  const fTransaction = async (e) => {
    dispatch(
      Set_LoadingList_HeadObject_Set({
        ...vRdxWmsHead,
        Transaction: e.target.value,
      })
    );
  };

  const fTruck = async (e) => {
    let vTruckObj = sTruckArr.find((obj) => {
      return obj.UId === e.target.value;
    });
    dispatch(
      Set_LoadingList_HeadObject_Set({
        ...vRdxWmsHead,
        Truck: e.target.value,
        Driver: vTruckObj?.Driver,
        DriverName: vTruckObj?.DriverName,
        TruckCBM: vTruckObj?.CBM,
      })
    );
  };

  const fUnloadingBay = async (e) => {
    dispatch(
      Set_LoadingList_HeadObject_Set({
        ...vRdxWmsHead,
        UnloadingBay: e.target.value,
      })
    );
  };

  const fDriver = async (e) => {
    dispatch(
      Set_LoadingList_HeadObject_Set({
        ...vRdxWmsHead,
        DriverName: e.target.value,
      })
    );
  };

  const fDriverEnter = async (e) => {
    if (e.key == "Enter") {
      document.getElementsByName("DriverName")[0]?.blur();
      fLoad_Release();
    }
  };

  const fTruckCBM = async (e) => {
    dispatch(
      Set_LoadingList_HeadObject_Set({
        ...vRdxWmsHead,
        TruckCBM: e.target.value,
      })
    );
  };

  const fItemCBM = async (e) => {
    dispatch(
      Set_LoadingList_HeadObject_Set({
        ...vRdxWmsHead,
        ItemCBM: e.target.value,
      })
    );
  };

  const fTotalWeignt = async (e) => {
    dispatch(
      Set_LoadingList_HeadObject_Set({
        ...vRdxWmsHead,
        TotalWeight: e.target.value,
      })
    );
  };

  const fLoadingListCheckBox = async (e) => {
    const nameValue = e.target.name;
    const iSCheck = e.target.checked;
    let LoadingListWithChecked = vRdxLoadingListUserCheckbox.map((obj) => {
      if (obj.UId === nameValue) {
        return { ...obj, Flag: iSCheck ? "Y" : "N" };
      } else {
        return obj;
      }
    });
    dispatch(
      Set_LoadingList_HeadLoadingListUserCheckbox(LoadingListWithChecked)
    );
  };

  const fGrnDate = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      dispatch(
        Set_LoadingList_HeadObject_Set({
          ...vRdxWmsHead,
          A_PostDt: "",
        })
      );
    } else {
      dispatch(
        Set_LoadingList_HeadObject_Set({
          ...vRdxWmsHead,
          A_PostDt: event?.$d,
        })
      );
    }

    // dispatch(
    //   Set_LoadingList_HeadObject_Set({ ...vRdxWmsHead, A_PostDt: !!event.$d
    //     ? event.$d:""})
    // );
  };

  const xfGC_Toggle_Head_Customer_Name = (e) => {
    dispatch(
      Set_LoadingList_HeadObject_Set({
        ...vRdxWmsHead,
        A_PartyName: e.target.value,
      })
    );
  };

  const [
    sGC_Toggle_Head_Customer_SearchDropdownObj,
    setGC_Toggle_Head_Customer_SearchDropdownObj,
  ] = useState({
    Type: "Any",
    Data: "",
  });

  const [
    sGC_Toggle_Head_Customer_GridData,
    setGC_Toggle_Head_Customer_GridData,
  ] = useState([]);

  const [
    sGC_Toggle_Head_Customer_ToggleDropDowm,
    setGC_Toggle_Head_Customer_ToggleDropDowm,
  ] = useState(false);

  const xfGC_Toggle_Head_Customer_Toggle = useCallback(() => {
    if (sGC_Toggle_Head_Customer_ToggleDropDowm) {
      setGC_Toggle_Head_Customer_ToggleDropDowm(false);
      setGC_Toggle_Head_Customer_GridData([]);
      setGC_Toggle_Head_Customer_SearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setGC_Toggle_Head_Customer_ToggleDropDowm(true);
    }
  }, [sGC_Toggle_Head_Customer_ToggleDropDowm]);

  //2nd call
  const fGC_Toggle_Head_Customer_Dropdown_SearchModalKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setGC_Toggle_Head_Customer_SearchDropdownObj((obj) => ({
        ...obj,
        Data: vRdxWmsHead.A_PartyName,
      }));
      if (vRdxWmsHead.A_PartyName != "") {
        const vExactSearch = await Get_ToggleDropDown_Load(
          vRdxWmsHead.A_PartyName,
          "Any",
          "W",
          "N",
          dispatch
        );
        if (vExactSearch.length > 0) {
          setGC_Toggle_Head_Customer_GridData(vExactSearch);
        } else {
          setGC_Toggle_Head_Customer_GridData([]);
        }
      }
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
      xfGC_Toggle_Head_Customer_Toggle();
    }
  };

  //1stcall
  const fGC_Toggle_Head_Customer_onKeyUp = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      const vExactSearch = await Get_ToggleDropDown_Load(
        vRdxWmsHead.A_PartyName,
        "Any",
        "W",
        "Y",
        dispatch
      );
      // let iDefaultTaxType = await GetTransTaxType(
      //   vRdxuserLoc[0].UID,
      //   vExactSearch[0]?.AcCd
      // );

      if (vExactSearch.length > 0) {
        dispatch(
          Set_LoadingList_HeadObject_Set({
            ...vRdxWmsHead,
            A_Party: vExactSearch[0]?.AcCd,
            A_PartyName: vExactSearch[0]?.Name1,
          })
        );
      } else {
        fGC_Toggle_Head_Customer_Dropdown_SearchModalKey(e);
      }
    }
    if (e.key === "Backspace") {
      dispatch(
        Set_LoadingList_HeadObject_Set({
          ...vRdxWmsHead,
          A_Party: "",
          A_PartyName: e.target.value,
        })
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById("table-main-grid-dropdown");
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const fGC_Toggle_Head_Customer_Dropdown_onChange = (e) => {
    setGC_Toggle_Head_Customer_SearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fGC_Toggle_Head_Customer_Dropdown_OnKeyUp_Load = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      const vExactSearch = await Get_ToggleDropDown_Load(
        sGC_Toggle_Head_Customer_SearchDropdownObj.Data,
        sGC_Toggle_Head_Customer_SearchDropdownObj.Type,
        "W",
        "N",
        dispatch
      );
      if (vExactSearch.length > 0) {
        setGC_Toggle_Head_Customer_GridData(vExactSearch);
      } else {
        setGC_Toggle_Head_Customer_GridData([]);
      }
    }
    //   id="table-main-grid-dropdown"

    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };
  const fGC_Toggle_Head_Customer_OnRowClick = async (e) => {
    dispatch(
      Set_LoadingList_HeadObject_Set({
        ...vRdxWmsHead,
        A_Party: e?.row?.AcCd,
        A_PartyName: e?.row?.Name1,
      })
    );

    xfGC_Toggle_Head_Customer_Toggle();
  };

  const fGC_Toggle_Head_Customer_OnCellKeyDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fGC_Toggle_Head_Customer_OnRowClick(newSelectionModel);
    }
  };
  //HEAD end

  //deteail

  //detail grid
  //detailgrid
  const [GridDataColumnsWmsSiDetail, setGridDataColumnsWmsSiDetail] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },

    {
      field: "detail",
      headerName: "Detail",
      hide: false,
      width: 100,
      renderCell: (params) => {
        return (
          <Button
            size="small"
            color="primary"
            onClick={() => {
              fDetailshowModal(params);
            }}
          >
            Detail
          </Button>
        );
      },
    },
    {
      field: "print",
      headerName: "Print",
      hide: false,
      width: 100,
      renderCell: (params) => {
        return (
          <Button
            size="small"
            color="primary"
            onClick={() => {
              fPrintshowModal(params);
            }}
          >
            Print
          </Button>
        );
      },
    },

    { field: "VocName", headerName: "VocName", width: 200 },
    { field: "B_RefDocTyp", headerName: "RefDoc", width: 100, hide: true },
    { field: "B_RefDocNo", headerName: "RefDocNo", width: 100 },
    { field: "B_Party", headerName: "Party", width: 100, hide: true },
    { field: "PartyName", headerName: "PartyName", width: 300, hide: false },
    { field: "B_Cluster", headerName: "Cluster", width: 100, hide: true },
    { field: "ClusterName", headerName: "ClusterName", width: 150 },
    { field: "B_Typ", headerName: "Typ", width: 100, hide: true },
    {
      field: "B_CBM",
      headerName: "CBM",
      width: 90,
      headerAlign: "right",
      align: "right",
    },
    {
      field: "B_Weight",
      headerName: "Weight",
      width: 100,
      headerAlign: "right",
      align: "right",
    },
  ]);

  const fDetailshowModal = (params) => {
    //xVocTyp,xVocNo,xRefDocTyp,xRefDocNo,xTyp
    fGridDetail(
      vRdxWmsHead.A_VocTyp,
      vRdxWmsHead.A_VocNo,
      params.row.B_RefDocTyp,
      params.row.B_RefDocNo,
      params.row.B_Typ
    );
  };

  const fPrintshowModal = (params) => {
    fPrintGrid(
      params?.row?.TrnTyp,
      params?.row?.B_RefDocTyp,
      params?.row?.B_RefDocNo
    );
  };

  const [selectedRows, setSelectedRows] = useState([]);
  //sIsSelectedY -true means checkbox hide
  const [sIsSelectedY, setIsSelectedY] = useState([]);

  const handleSelectionChange = (params) => {
    setSelectedRows(params);
    let modifiedSelect = sDetailGridData.map((el) => {
      if (params.includes(el.id)) {
        return { ...el, Selected: "Y" };
      } else {
        return { ...el, Selected: "N" };
      }
    });

    setDetailGridData(modifiedSelect);
  };

  const DummySelectionChange = (params) => {};
  const [sDetailGridData, setDetailGridData] = useState([
    // {
    //   B_RefDocTyp: "WS001",
    //   VocName: "WMS SALES INVOICE-SDC",
    //   B_RefDocNo: "SISD000001",
    //   B_Party: "D0001",
    //   PartyName: "SONAS WHOLESALE POINT LLC-AJMAN",
    //   B_Cluster: "LCCLAJM",
    //   ClusterName: "AJMAN",
    //   B_Typ: "Full",
    //   B_CBM: 6.2025,
    //   B_Weight: 5790,
    //   id: 1,
    //   Selected: "Y",
    // },
  ]); //DetailGridData Select

  const fDetail_Grid_onRowClick = async (item) => {
    // dispatch(
    //   Set_LoadingList_HeadObject_Set({
    //     ...vRdxWmsHead,
    //     A_VocTyp: item.row.B_RefDocTyp,
    //     A_VocTypName: item.row.VocName,
    //     Cluster: item.row.B_Cluster,
    //     Transaction: item.row,
    //     UnloadingBay: item.row,
    //     Truck: item.row,
    //     A_Type: item.row,
    //   })
    // );
  };
  //detail grid end

  //detail end

  //PRINT
  const sTrnTyp = "LOACDINGLIST_LDST";
  const vRdxDBBranchList = useSelector(
    (state) => state.SliceDB.value.DBBranchList
  );
  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");
  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };

  const fPrint = useCallback(
    (xPrnTyp) => {
      let vrdl = vRdxDBBranchList.find((obj) => {
        return obj.LocName[0] == vRdxWmsHead.A_Loc;
      });
      let webReport = vRdxDBKernObj.WEB_REPORT_BASE_URL 
      //  http://192.168.50.243:8010/WebReports/WMS/LoadingList?prntyp=WMLDLSTD&VocTyp=LD001&VocNo=LDSDC00002

      if (vrdl?.InvoiceFile != "") {
        let urlPrint =
          webReport?.Val +
          "WMS/LoadingList?prntyp=" +
          xPrnTyp +
          "&VocTyp=" +
          vRdxWmsHead.A_VocTyp +
          "&VocNo=" +
          vRdxWmsHead.A_VocNo;
        setWebReportUrlModal(urlPrint);
        fWebReport();
      } else {
        let urlPrint =
          webReport?.Val +
          "WMS/LoadingList?prntyp=" +
          xPrnTyp +
          "&VocTyp=" +
          vRdxWmsHead.A_VocTyp +
          "&VocNo=" +
          vRdxWmsHead.A_VocNo;
        setWebReportUrlModal(urlPrint);
        fWebReport();
      }
    },
    [
      vRdxWmsHead.A_Loc,
      vRdxWmsHead.A_VocNo,
      vRdxWmsHead.A_VocTyp,
      vRdxDBKernObj,
      vRdxDBBranchList,
    ]
  );
  //PRINT END

  //GRIDPRINT START
  const fPrintGrid = (xTrnType = "", xA_VocTyp = "", xA_VocNo = "") => {
    let vrdl = vRdxDBBranchList.find((obj) => {
      return obj.LocName[0] == vRdxWmsHead.A_Loc;
    });
    let webReport =vRdxDBKernObj.WEB_REPORT_BASE_URL 
    let webUrl = "";
    if (xTrnType === "WMINV08") {
      webUrl =
        "sales?trntyp=" +
        xTrnType +
        "&voctyp=" +
        xA_VocTyp +
        "&vocno=" +
        xA_VocNo +
        "&prnTyp=" +
        "PF" +
        "&amountInWord=''";
    } else if (xTrnType === "WMINV04") {
      webUrl =
        "WMS/GRV?trntyp=" +
        xTrnType +
        "&voctyp=" +
        xA_VocTyp +
        "&vocno=" +
        xA_VocNo +
        "&prnTyp=" +
        "P";
    } else if (xTrnType === "WMINV10") {
      webUrl = "Progress";
    }

    if (vrdl?.InvoiceFile != "") {
      let urlPrint = webReport?.Val + webUrl + "&rdl=" + vrdl?.InvoiceFile;

      setWebReportUrlModal(urlPrint);
      fWebReport();
    } else {
      let urlPrint = webReport?.Val + webUrl;
      setWebReportUrlModal(urlPrint);
      fWebReport();
    }
  };
  //GRIDPRINT END

  //PrintAllDocument start
  const fPrintAllDocument = () => {
    const selectedDetailGridData = sDetailGridData.filter(
      (obj) => obj.Selected === "Y"
    );
    for (var obj of selectedDetailGridData) {
      fPrintGrid(obj.TrnTyp, obj.B_RefDocTyp, obj.B_RefDocNo);
    }
  };
  //PrintAllDocument END
  //Modal view
  const [sViewModal, setViewModal] = useState(false);
  const fView = () => {
    setViewModal(true);
  };

  const fCloseViewModal = (e) => {
    setViewModal(false);
  };

  //Modal view end

  //Modal GridDetail
  const [sGridDetailModal, setGridDetailModal] = useState(false);
  const [sGridDetailRowModal, setGridDetailRowModal] = useState([]);
  const [sGridDetailColumnModal, setGridDetailColumnModal] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "C_RefSrNo", headerName: "SrNo", width: 90 },
    { field: "C_ItmCd", headerName: "Item Code", width: 150 },
    { field: "ItmName", headerName: "ItmName", width: 300 },
    { field: "C_Qty", headerName: "Qty", width: 50 },
    { field: "C_Unit", headerName: "Unit", width: 100 },
    { field: "C_BaseQty", headerName: "BaseQty", width: 90 },
    { field: "C_Per_CBM", headerName: "CBM", width: 150 },
    { field: "C_Tot_CBM", headerName: "Item CBM", width: 150 },
    { field: "C_Tot_Weight", headerName: "Weight", width: 150 },

    { field: "C_NDX_ROWID", headerName: "C_NDX_ROWID", width: 500, hide: true },
    {
      field: "C_Per_Weight",
      headerName: "C_Per_Weight",
      width: 150,
      hide: true,
    },

    { field: "LDQty", headerName: "LDQty", width: 150, hide: true },
    { field: "BalQty", headerName: "BalQty", width: 150, hide: true },
  ]);
  const fGridDetail = async (xVocTyp, xVocNo, xRefDocTyp, xRefDocNo, xTyp) => {
    // LoadingList_TransDetail_GETROW
    let iGridDetailApiObj = {
      VocTyp: xVocTyp,
      VocNo: xVocNo,
      RefDocTyp: xRefDocTyp,
      RefDocNo: xRefDocNo,
      Typ: xTyp,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(iGridDetailApiObj);

    const iSIDetailResult = await fExecuteAPI(
      "LoadingList_TransDetail_GETROW",
      FinalObj
    );
    if (iSIDetailResult?.Type?.toUpperCase() === "SUCCESS") {
      if (iSIDetailResult.ResultSet.length > 0) {
        let GridID = iSIDetailResult.ResultSet?.map((obj, i) => ({
          ...obj,
          id: i + 1,
        }));
        setGridDetailRowModal(GridID);
      } else {
        setGridDetailRowModal([]);
      }
    } else {
      fAlertToast(
        "FAILED",
        iSIDetailResult.response.data.message
          ? iSIDetailResult.response.data.message
          : "Error in GridLoadPendingItems"
      );
    }
    setGridDetailModal(true);
  };

  const fCloseGridDetailModal = (e) => {
    setGridDetailRowModal([]);
    setGridDetailModal(false);
  };

  //Modal GridDetail end

  //Modal Summary
  const [sSummaryModal, setSummaryModal] = useState(false);
  const fSummary = () => {
    setSummaryModal(true);
  };

  const fCloseSummaryModal = (e) => {
    setSummaryModal(false);
  };

  //Modal Summary end

  //Modal Audit

  const [xAuditId, setAuditId] = useState("All");
  const [sAuditModal, setAuditModal] = useState(false);
  const [sAuditSelectArr, setAuditSelectArr] = useState([]);
  const [sGridDataAuditRows, setGridDataAuditRows] = useState([]);
  const fOpenAuditModal = () => {
    setAuditModal(true);
  };
  const fAudit = async (e) => {
    let auditResp = await GetAuditField();
    if (!!auditResp) {
      setAuditId(auditResp[0]?.id);
      GetTransAudit(auditResp[0]?.id);
    }
    fOpenAuditModal();
  };
  const fCloseAuditModal = (e) => {
    setAuditModal(false);
  };
  const fonChangeAuditSelect = (e) => {
    setAuditId(e.target.value);
    GetTransAudit(e.target.value);
  };
  //API AUDITFIELD_GETROW
  let sTransTypeAudit = "WMLDLST";
  const GetAuditField = async () => {
    // http://localhost:3999/RpDesign/auditFields?trnTyp=WMINV08
    const vAuditField = await fExecuteAPI("AUDITFIELD_GETROW", sTransTypeAudit);
    if (vAuditField.Type?.toUpperCase() === "SUCCESS") {
      setAuditSelectArr(vAuditField.ResultSet);
      return vAuditField.ResultSet;
    } else {
      fAlertToast("FAILED", vAuditField?.Message);
      return vAuditField.ResultSet;
    }
  };
  //API TRANSAUDIT_GETROW
  const GetTransAudit = async (xid) => {
    let vTransAuditObj = {
      vocTyp: vRdxWmsHead.A_VocTyp,
      vocNo: vRdxWmsHead.A_VocNo,
      trnTyp: sTransTypeAudit,
      field: xid,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vTransAuditObj);
    const vTransAudit = await fExecuteAPI("TRANSAUDIT_GETROW", FinalObj);
    if (vTransAudit.Type?.toUpperCase() === "SUCCESS") {
      let vTransAuditRes = vTransAudit.ResultSet.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setGridDataAuditRows(vTransAuditRes);
    } else {
      fAlertToast("FAILED", vTransAudit?.Message);
    }
  };

  //MODAL AUDIT END

  //accountDetail start
  const [sAccountDetailModal, setAccountDetailModal] = useState(false);
  const [sGridDataAccountDetailRows, setGridDataAccountDetailRows] = useState(
    []
  );
  const [sGridDataAccountDetailColumns, setGridDataAccountDetailColumns] =
    useState([
      {
        field: "id",
        headerName: "Sr.No",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "AcCd",
        headerName: "AcCd",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "AcName",
        headerName: "AcName",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "Br",
        headerName: "Br",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "BrName",
        headerName: "BrName",
        width: 130,
        headerClassName: "grid-header-row",
      },

      {
        field: "AmtLc",
        headerName: "AmtLc",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "DrCr",
        headerName: "DrCr",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "Narr",
        headerName: "Narr",
        width: 200,
        headerClassName: "grid-header-row",
      },
      {
        field: "Narr1",
        headerName: "Narr1",
        width: 200,
        headerClassName: "grid-header-row",
      },
    ]);
  const fOpenAccountDetailModal = () => {
    setAccountDetailModal(true);
  };
  const fAccountDetail = async (e) => {
    const { HeadObject } = RoLoadingLists();
    await GetAccountPostingDetail(
      HeadObject.A_VocTyp,
      HeadObject.A_VocNo,
      setGridDataAccountDetailRows
    );

    fOpenAccountDetailModal();
  };
  const fCloseAccountDetailModal = (e) => {
    setAccountDetailModal(false);
  };
  //accountDetail end

  //fLinkDocument start
  const [sLinkDocumentModal, setLinkDocumentModal] = useState(false);
  const [sGridDataLinkDocumentRows, setGridDataLinkDocumentRows] = useState([]);
  const [sGridDataLinkDocumentColumns, setGridDataLinkDocumentColumns] =
    useState([
      {
        field: "A_VocTyp",
        headerName: "Doc.Type",
        hide: false,
        width: 80,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "VocName",
        headerName: "Doc.Name",
        hide: false,
        width: 180,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "A_VocNo",
        headerName: "Doc.No",
        hide: false,
        width: 80,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "A_DocStat",
        headerName: "Status",
        hide: false,
        width: 50,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "id",
        headerName: "id",
        hide: false,
        width: 40,
        align: "left",
        headerAlign: "left",
      },
    ]);
  const fOpenLinkDocumentModal = () => {
    setLinkDocumentModal(true);
  };
  const fLinkDocument = async (e) => {
    const { HeadObject } = RoLoadingLists();
    await GetLinkDocument(
      HeadObject.A_VocTyp,
      HeadObject.A_VocNo,
      sTrnTyp,
      setGridDataLinkDocumentRows
    );

    fOpenLinkDocumentModal();
  };
  const fCloseLinkDocumentModal = (e) => {
    setLinkDocumentModal(false);
  };
  //LinkDocument end

  //MODAL SEARCH
  const vMediaQuery = useMediaQuery("(max-width:450px)");
  const sEnterKeyObj = {
    key: "Enter",
  };
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const [sGridSearchHeadRowData, setGridSearchHeadRowData] = useState([]);
  const [sSearchLoactionArr, setSearchLoactionArr] = useState(sLocationArr);
  const addAllInSearchLoactionArr = () => {
    const newObj = {
      UID: "All",
      Name1: "All",
    };

    // Use the spread operator to create a new array with the new object added at the beginning
    setSearchLoactionArr([newObj, ...sLocationArr]);
  };
  const [sSearchModalObj, setSearchModalObj] = useState({
    Status: sStatusArr[0],
    VocNo: "",
    PostDt: "",
    Loc: "All",
    RefNo: "",
  });

  const [sSearchModal, setSearchModal] = useState(false);
  const fSearch = async () => {
    setSearchModal(true);

    document.getElementById("IdSearch")?.blur();
    // SALESGROUPSSEARCH_GETROW -search salegroup dropdown
    addAllInSearchLoactionArr();
    setSearchModalObj((obj) => ({
      ...obj,
      Loc: "All",
    }));
    GetSearchValue("", "APICallLocModal", "All");
  };

  const fCloseSearchModal = (e) => {
    setSearchModal(false);
    fClearSearchModal();
  };

  const fClearSearchModal = (e) => {
    setSearchModalObj({
      Status: "ENTER",
      VocNo: "",
      PostDt: "",
      Loc: "All",
      RefNo: "",
    });
    setGridSearchHeadRowData([]);
  };

  //GCSearch
  const fTrans_Search_Grid_RowClick = (e) => {
    fDisplay(e?.row?.A_VocTyp, e?.row?.A_VocNo);
    fCloseSearchModal();
  };

  const fonChangeStatusModal = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((value, index) => {
      return value == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      Status: vSelectedValue,
    }));

    GetSearchValue("", "APICALLSTATUS", vSelectedValue);
  };

  const fonChangeVocNoModal = (event) => {
    setSearchModalObj((obj) => ({
      ...obj,
      VocNo: event.target.value,
    }));
  };

  const fonChangeRefNoModal = (event) => {
    setSearchModalObj((obj) => ({
      ...obj,
      RefNo: event.target.value,
    }));
  };

  const fOnChangeDateModel = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      setSearchModalObj((obj) => ({
        ...obj,
        PostDt: "",
      }));
    } else {
      setSearchModalObj((obj) => ({
        ...obj,
        PostDt: event?.$d,
      }));
    }

    let changedDate = event?.$d;
    if (new Date(event?.$d) >= new Date("01-01-1990")) {
      GetSearchValue("", "APICALLDATE", changedDate);
    }
  };

  const fonChangeLocModal = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((obj, index) => {
      return obj.UId == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      Loc: vSelectedValue.UId,
    }));
    GetSearchValue("", "APICallLocModal", vSelectedValue.UId);
  };

  const GetSearchValue = async (e, xAPICALL, xSTATUS) => {
    if (
      e.key === "Enter" ||
      xAPICALL === "APICALLSTATUS" ||
      xAPICALL === "APICALLDATE" ||
      xAPICALL === "APICallLocModal"
    ) {
      let iPostdt =
        xAPICALL === "APICALLDATE"
          ? moment(xSTATUS).format("MM/DD/YYYY")
          : moment(sSearchModalObj.PostDt).format("MM/DD/YYYY");
      if (
        iPostdt == "Invalid date" ||
        iPostdt == null ||
        iPostdt === undefined ||
        iPostdt === ""
      ) {
        iPostdt = "01/01/1900";
      }

      let vSearchObj = {
        Status: xAPICALL === "APICALLSTATUS" ? xSTATUS : sSearchModalObj.Status,
        VocNo: sSearchModalObj.VocNo,
        VocDt: iPostdt,
        // VocDt: "01/01/1900",
        RefVocNo: sSearchModalObj.RefNo,
        Loc: xAPICALL === "APICallLocModal" ? xSTATUS : sSearchModalObj.Loc,
        v_UserCd: vRdxuserInfo.UserID,
      };
      let FinalObj = fcheck_null_undefine_replace_empty(vSearchObj);
      const vSearch = await fExecuteAPI(
        "LoadingList_LoadingSearch_GETROW",
        FinalObj
      );
      if (vSearch.Type?.toUpperCase() === "SUCCESS") {
        let vSearchArr = vSearch?.ResultSet.map((obj, i) => ({
          ...obj,
          id: i + 1,
          // A_VocDt: moment(obj.A_VocDt).format("DD/MM/YYYY"),
        }));
        setGridSearchHeadRowData(vSearchArr);
      } else {
        fAlertToast("FAILED", vSearch?.response?.data?.Status);
      }
    }
  };

  //MODAL SEARCH END

  //MODAL REVERSE START
  const [sReverseTransactionModal, setReverseTransactionModal] =
    useState(false);
  const [sRevNarr, setRevNarr] = useState(""); //for Reverse API
  const fOpenReverseTransactionModal = () => {
    setReverseTransactionModal(true);
  };
  const fCloseReverseTransactionModal = (e) => {
    setReverseTransactionModal(false);
  };
  const fReverse = (e) => {
    fCloseReverseTransactionModal();
    confirmAlert({
      title: "Reverse",
      message: "Are you sure to Reverse.",
      buttons: [
        {
          className: "alertBtn",
          label: "Yes",
          onClick: () => fSave(),
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => setRevNarr(""),
        },
      ],
    });
  };

  //API REVERSETRANSACTION_GETROW
  const GetRevereTransaction = async () => {
    let vRevereTransactionObj = {
      vocType: vRdxWmsHead.A_VocTyp,
      vocNo: vRdxWmsHead.A_VocNo,
      userId: vRdxuserInfo.UserID,
      Ipaddress: vRdxuserInfo.IP,
    };
    const vRevereTransaction = await fExecuteAPI(
      "LoadingList_Reverse_GETROW",
      vRevereTransactionObj
    );
    return vRevereTransaction;
  };
  //MODAL REVERSE END

  //nav function
  const fClearErrorMsg = () => {
    setErrorMsg(ErrorMsg);
    // setErrorMsgDetail(ErrorMsgDetail);
  };

  const fNew = () => {
    fClearErrorMsg();
    fNewHead();
    fNewDetail(0, sDocLoading[0]?.VocTyp);
    document.getElementsByName("A_PostDt")[0]?.focus();
  };

  const fNewHead = async () => {
    dispatch(Set_LoadingList_HeadObject_Init()); // Head Clearing
    // Setting Initial List Box 0th Object
    dispatch(
      Wms_LoadingList_HeadObject_New_Set({
        A_VocTyp: sDocLoading[0]?.VocTyp,
        A_VocTypName: sDocLoading[0]?.VocName,
        A_VocNo: 0,
        Cluster: sClusterArr[0]?.UId,
        A_Loc: sLocationArr[0]?.UID,
        Transaction: sTransactionArr[0]?.UId,
        UnloadingBay: sUnloadingBayArr[0]?.UId,
        Truck: sTruckArr[0]?.UId,
        A_Type: sLoadingTypeArr[0], //sForm
        TruckCBM: sTruckArr[0]?.CBM,
        Driver: sTruckArr[0]?.Driver,
        DriverName: sTruckArr[0]?.DriverName,
        A_Party: AllPartyFlag() ? "ALL" : "",
        A_PartyName: AllPartyFlag() ? "ALL" : "",
      })
    );

    setNavDocValue(1); // nav init 1
    setDetailGridData([]);
    // setBufferObj(vBufferObjInit);
    let vLoadingListCheckboxArr = await GetLoadingListCheckbox(
      sDocLoading[0]?.VocTyp,
      0,
      dispatch
    );
    if (vLoadingListCheckboxArr.length > 0) {
      dispatch(
        Set_LoadingList_HeadLoadingListUserCheckbox(vLoadingListCheckboxArr)
      );
    }

    // document.getElementsByName("A_RefDocNo")[0]?.focus();
  };

  const fNewDetail = (xVocNo, xVocTyp) => {
    // setBufferObj(vBufferObjInit);

    fLoad_Grid(xVocNo, xVocTyp);

    document.getElementsByName("DriverName")[0]?.focus();
  };

  const fLoad_Grid = async (xB_VocNo, xVocTyp) => {
    const iSIDetail = await GetSIDetail(xB_VocNo, xVocTyp);
    if (iSIDetail?.length > 0) {
      const newArray = iSIDetail.map((object, index) => {
        return { ...object, detail: "", print: "" };
      });
      setDetailGridData(newArray);
      var iTotalWeight = 0,
        iItemCBM = 0;

      for (let i = 0; i < iSIDetail?.length; i++) {
        iTotalWeight += iSIDetail[i]?.B_Weight;
        iItemCBM += iSIDetail[i]?.B_CBM;
      }
      dispatch(
        Wms_LoadingList_Footer_CBM({
          ItemCBM: iItemCBM.toFixed(2),
          TotalWeight: iTotalWeight.toFixed(2),
        })
      );
      for (const obj of iSIDetail) {
        if (obj.Selected === "Y") {
          setSelectedRows((prevSelectedRows) => [...prevSelectedRows, obj.id]);
        }
      }
      var iIsSelectedY = iSIDetail.find((obj) => {
        return obj.Selected === "Y";
      });
      if (!!iIsSelectedY) {
        setIsSelectedY(true);
        setSelectedRows([]);
      } else {
        setIsSelectedY(false);
      }
    } else {
      setDetailGridData([]);
      dispatch(
        Wms_LoadingList_Footer_CBM({
          ItemCBM: 0,
          TotalWeight: 0,
        })
      );
    }
  };

  const fSaveHead = async (
    xSave = false,
    xbtnName = "",
    xDocStatus = "POST"
  ) => {
    if (xbtnName != "LoadRelease") {
      const selectedDetailGridData = sDetailGridData.filter(
        (obj) => obj.Selected === "Y"
      );
      if (selectedDetailGridData.length == 0) {
        fAlertToast("FAILED", "Add atleast one line item");
        return;
      }
    }
    const iStatus = xSave ? vRdxWmsHead.A_DocStat : xDocStatus; //xSave False means Post
    let vSaveSIHeadObj = {
      A_VocTyp: vRdxWmsHead.A_VocTyp,
      A_VocNo: vRdxWmsHead?.A_VocNo,
      A_VocDt: moment(vRdxWmsHead.A_PostDt).format("MM/DD/YYYY"),
      A_Loc: vRdxWmsHead.A_Loc,
      A_Cluster: vRdxWmsHead.Cluster,
      A_Party: vRdxWmsHead.A_Party,
      A_Truck: vRdxWmsHead.Truck,
      A_Driver: vRdxWmsHead.Driver,
      UserCd: vRdxuserInfo.UserID,
      IP: vRdxuserInfo.IP,
      A_DocStat: iStatus,
      A_TruckCBM: vRdxWmsHead.TruckCBM,
      A_Tot_CBM: vRdxWmsHead.ItemCBM,
      A_Tot_Weight: vRdxWmsHead.TotalWeight,
      A_Trans: vRdxWmsHead.Transaction,
      A_LDPAY: vRdxWmsHead.UnloadingBay,
      A_LDTYPE: vRdxWmsHead.A_Type,
      Party_name: vRdxWmsHead.A_PartyName,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIHeadObj);

    const vSaveSIHead = await fExecuteAPI(
      "LoadingList_FupdateHead_GETROW",
      FinalObj
    );

    if (vSaveSIHead?.Type?.toUpperCase() == "SUCCESS") {
      if (vRdxWmsHead.A_VocNo == "0") {
        setUser_Doc_Arr([
          ...sUser_Doc_Arr,
          {
            A_VocTyp: vRdxWmsHead.A_VocTyp,
            A_VocNo: vSaveSIHead?.ResultSet[0]?.VocNo,
            SrNo: sUser_Doc_Arr.length + 1,
          },
        ]);
      }

      dispatch(
        Set_LoadingList_HeadObject_A_VocNo({
          A_VocNo: xSave
            ? vSaveSIHead?.ResultSet[0]?.VocNo
            : vRdxWmsHead.A_VocNo,
          A_DocStat: iStatus,
        })
      );
      //approve bool type false
      if (!xSave) {
        fDisplay(
          vRdxWmsHead.A_VocTyp,
          xSave ? vSaveSIHead?.ResultSet[0]?.A_VocNo : vRdxWmsHead.A_VocNo
        );

        fAlertToast("SUCCESS", "Successfully posted");
      } else if (xbtnName == "LoadRelease") {
        let iReleaseObj = {
          B_VocTyp: vRdxWmsHead.A_VocTyp,
          B_VocNo: vSaveSIHead?.ResultSet[0]?.VocNo,
        };
        // eslint-disable-next-line no-unused-vars
        const vRelease = await fExecuteAPI(
          "LoadingList_Release_GETROW",
          iReleaseObj
        );
        setSelectedRows([]);
        fLoad_Grid(vSaveSIHead?.ResultSet[0]?.VocNo, vRdxWmsHead.A_VocTyp);
        fAlertToast("SUCCESS", "Successfully loaded");
      } else {
        fSaveDetail(vSaveSIHead?.ResultSet[0]?.VocNo, vRdxWmsHead.A_VocTyp);
      }
    } else {
      fAlertToast("FAILED", vSaveSIHead?.response?.data?.message);
    }
  };

  const fSaveDetail = async (xB_VocNo, XA_VocTyp) => {
    // sDetailGridData

    // const uniqueId = [...new Set(selectedRows)];
    // const selectedGridObjects = sDetailGridData.filter((obj) =>
    //   uniqueId.includes(obj.id)
    // );
    const selectedDetailGridData = sDetailGridData.filter(
      (obj) => obj.Selected === "Y"
    );
    const selectedGridData = selectedDetailGridData.map((obj) => ({
      RefDocTyp: obj.B_RefDocTyp,
      RefDocNo: obj.B_RefDocNo,
      Party: obj.B_Party,
      Cluster: obj.B_Cluster,
      Typ: obj.B_Typ,
      CBM: obj.B_CBM,
      Weight: obj.B_Weight,
    }));

    const SelectedUserListObjects = vRdxLoadingListUserCheckbox.filter(
      (obj) => obj.Flag === "Y"
    );
    const selectedUserListData = vRdxLoadingListUser.map((obj) => ({
      UserCd: obj.UId,
    }));

    let vSaveSIDetailObj = {
      VocTyp: !!XA_VocTyp ? XA_VocTyp : "",
      VocNo: !!xB_VocNo ? xB_VocNo : "",
      Detail: selectedGridData,
      userList: selectedUserListData,
    };
    const vSaveSIDetail = await fExecuteAPI(
      "LoadingList_save_detail_GETROW",
      vSaveSIDetailObj
    );
    if (vSaveSIDetail?.Type?.toUpperCase() === "SUCCESS") {
      fNewDetail(xB_VocNo, XA_VocTyp);
      fAlertToast("SUCCESS", "Successfully Saved");
    } else {
      fAlertToast(
        "FAILED",
        vSaveSIDetail.Status || vSaveSIDetail.response.data.message
      );
    }
  };

  //API GETSIHEAD_GETROW to gethead
  const fDisplay = async (xA_VocTyp, xA_VocNo) => {
    let vSIHeadObj = {
      A_VocTyp: xA_VocTyp,
      A_VocNo: xA_VocNo,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vSIHeadObj);
    const vSIHead = await fExecuteAPI("LoadingList_getHead_GETROW", FinalObj);
    if (vSIHead?.Type?.toUpperCase() === "SUCCESS") {
      dispatch(
        Set_LoadingList_HeadObject_Set({
          ...vRdxWmsHead,
          A_VocTyp: vSIHead.ResultSet[0].A_VocTyp,
          // A_VocTypName: vSIHead.ResultSet[0].VocName,
          A_VocNo: vSIHead.ResultSet[0].A_VocNo,
          A_PostDt: vSIHead.ResultSet[0].A_VocDt,
          A_Loc: vSIHead.ResultSet[0].A_Loc,
          Cluster: vSIHead.ResultSet[0].A_Cluster || "All",
          A_Party: vSIHead.ResultSet[0].A_Party,
          A_PartyName: vSIHead.ResultSet[0].PartyName,
          Transaction: vSIHead.ResultSet[0].A_Trans,
          Truck: vSIHead.ResultSet[0].A_Truck,
          Driver: vSIHead.ResultSet[0].A_Driver,
          DriverName: vSIHead.ResultSet[0].DriverName ||  vSIHead.ResultSet[0].A_Driver,
          A_DocStat: vSIHead.ResultSet[0].A_DocStat,
          A_Type: vSIHead.ResultSet[0].A_LDTYPE,
          TruckCBM: vSIHead.ResultSet[0].A_TruckCBM,
          ItemCBM: vSIHead.ResultSet[0].A_Tot_CBM,
          TotalWeight: vSIHead.ResultSet[0].A_Tot_Weight,
          UnloadingBay: vSIHead.ResultSet[0].A_LDPAY, // Unloading Bin ID
          A_TransSrNo: vSIHead.ResultSet[0].A_TransSrNo, // Unloading Bin ID
        })
      );

      fNewDetail(vSIHead.ResultSet[0].A_VocNo, vSIHead.ResultSet[0].A_VocTyp);
      let vLoadingListCheckboxArr = await GetLoadingListCheckbox(
        vSIHead.ResultSet[0].A_VocTyp,
        vSIHead.ResultSet[0].A_VocNo,
        dispatch
      );
      if (vLoadingListCheckboxArr.length > 0) {
        dispatch(
          Set_LoadingList_HeadLoadingListUserCheckbox(vLoadingListCheckboxArr)
        );
        let iArr=vLoadingListCheckboxArr.filter(i => i.Flag == "Y")
        dispatch(
         dispatch(Set_LoadingList_HeadLoadingListUser(iArr))
        );
      }
    }
  };

  let timeout = null;

  // Updated Truck
  const [updatedTruck,setUpdatedTruck] = useState(false);

  const OpenUpdatedTruckModal = ()=>{
    setUpdatedTruck(true);
  }

  const CloseUpdatedTruckModal = ()=>{
    setUpdatedTruck(false);
  }
  
  const fUpdatedTruck = ()=>{
    const { HeadObject } = RoLoadingLists();
    if (
      HeadObject.A_VocTyp === "" ||
      HeadObject.A_VocTyp === null ||
      HeadObject.A_VocTyp === undefined
    ) {
      fAlertToast("FAILED", "VocTyp should not be empty");
      return;
    } else if (
      HeadObject.A_VocNo === "" ||
      HeadObject.A_VocNo === null ||
      HeadObject.A_VocNo === undefined
    ) {
      fAlertToast("FAILED", "VocNo should not be empty");
      return;
    } else if (
      HeadObject.A_VocNo == 0
    ) {
      fAlertToast("FAILED", "Save atleast one transaction");
      return;
    }else  {
      OpenUpdatedTruckModal();
    }
  }

  const fLoad_Release = () => {
    fSave("LoadRelease");
  };

  const fSave = (xbtnName = "", xsave = true, xDocStatus = "") => {
    fClearErrorMsg();
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (vRdxWmsHead.A_DocStat == "POST" || vRdxWmsHead.A_DocStat == "DRAFT") {
        if (sRevNarr == "") {
          fOpenReverseTransactionModal();
        } else {
          let reverseResp = await GetRevereTransaction();
          if (reverseResp?.Type?.toUpperCase() == "SUCCESS") {
            fClearErrorMsg();
            setRevNarr("");
            dispatch(
              Set_LoadingList_HeadObject_A_DocStat({
                A_DocStat: "ENTER",
              })
            );
            fAlertToast("SUCCESS", "SUCCESSFULLY REVERSED");
          } else {
            fAlertToast(
              "FAILED",
              reverseResp.response.data.Status ||
                reverseResp.response.data.message
            );
          }
        }
      } else if (vRdxWmsHead.A_DocStat != "ENTER") {
        fAlertToast(
          "FAILED",
          "Not allowed in " + vRdxWmsHead.A_DocStat.toLowerCase() + " mode"
        );
        return;
      } else {
        let validation = fValidationHead_Client(
          vRdxWmsHead,
          // vRdxLoadingListUserCheckbox,
          vRdxLoadingListUser,
          setErrorMsg
        );

        if (!validation) return;
        if (xbtnName != "LoadRelease") {
          if (Number(vRdxWmsHead.ItemCBM) > Number(vRdxWmsHead.TruckCBM)) {
            fAlertToast("FAILED", "Items CBM should be lesser then Truck CBM.");
            return;
          }
          // let objUserList =
          //   vRdxLoadingListUserCheckbox.find((el) => el.Flag === "Y") !==
          //   undefined;
          let objUserList =
          vRdxLoadingListUser 
          if (objUserList.length == 0) {
            fAlertToast("FAILED", "Atleat one user should be selected");
            return;
          }
        }

        fSaveHead(xsave, xbtnName, xDocStatus);
      }
    }, 800);
  };


  const fApprove = (xDocStatus) => {
    fSave("", false, xDocStatus);
  };

  const fDeleteHead = async () => {
    
    let vDeleteSIHeadObj = {
      A_VocTyp: vRdxWmsHead.A_VocTyp,
      A_VocNo: vRdxWmsHead.A_VocNo,
      // IP: vRdxuserInfo.IP,
      // UserId: vRdxuserInfo.UserID,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vDeleteSIHeadObj);
    // const vDeleteSIHead = await fExecuteAPI(
    //   "LoadingList_deleteHead_GETROW",
    //   FinalObj
    // );
    const vDeleteSIHead = await WMSloading_LoadingDelete001(FinalObj);
    if (vDeleteSIHead?.status === 200) {
      // vocno,srno
      dispatch(
        Set_LoadingList_HeadObject_A_DocStat({
          A_DocStat: "DELETE",
        })
      );
      fDisplay(vRdxWmsHead.A_VocTyp, vRdxWmsHead.A_VocNo);
      // fNewDetail(
      //   vRdxWmsHead.A_VocNo,
      //   vRdxWmsHead.A_VocTyp,
      // );
      fAlertToast("SUCCESS", "Successfully Deleted");
    }  
  };

  const fDelete = () => {
    if (vRdxWmsHead.A_DocStat == "POST") {
      fAlertToast("FAILED", "You are not allowed to delete in post status");
      return;
    }
    if (vRdxWmsHead.A_DocStat == "ENTER") {
      confirmAlert({
        title: "Delete",
        message: "Are you want to delete.",
        buttons: [
          {
            className: "alertBtn",
            name: "DeletYes",
            label: "Yes",
            onClick: () => {
              fDeleteHead();
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
      setTimeout(() => {
        document.getElementsByName("DeletYes")[0]?.focus();
      }, 100);
    }
  };

  const fMove_First = () => {
    fClearErrorMsg();
    fDisplay(sUser_Doc_Arr[0].A_VocTyp, sUser_Doc_Arr[0].A_VocNo);
    setNavDocValue(1);
  };

  const fMove_Previouse = () => {
    fClearErrorMsg();
    if (sNavDocValue > 1) {
      var row = sNavDocValue - 1;
      fDisplay(sUser_Doc_Arr[row - 1].A_VocTyp, sUser_Doc_Arr[row - 1].A_VocNo);
      setNavDocValue(row);
    }
  };
  const fMove_Next = () => {
    fClearErrorMsg();

    if (sNavDocValue < sUser_Doc_Arr.length) {
      var row = sNavDocValue + 1;
      fDisplay(sUser_Doc_Arr[row - 1].A_VocTyp, sUser_Doc_Arr[row - 1].A_VocNo);
      setNavDocValue(row);
    }
  };

  const fMove_Last = () => {
    fClearErrorMsg();
    fDisplay(
      sUser_Doc_Arr[sUser_Doc_Arr.length - 1].A_VocTyp,
      sUser_Doc_Arr[sUser_Doc_Arr.length - 1].A_VocNo
    );
    setNavDocValue(sUser_Doc_Arr.length);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onload = useCallback(async () => {
    let iAttributeResp = await GetAttributes(
      setUser_Doc_Arr,
      setObjectRights,
      setDocLoading,
      setClusterArr,
      setLocationArr,
      setTransactionArr,
      setTruckArr,
      setUnloadingBayArr
    );
    // let vLoad_User_Doc = await fLoad_User_Doc(dispatch);
    //  let vDocLoadingArr = await GetDocLoading(dispatch);
    // let vClusterArr = await GetCluster(dispatch);
    // let vLocationArr = await GetLocation(dispatch);
    // let vTransactionArr = await GetTransaction(dispatch);
    // let vLoadingBayArr = await GetLoadingBay(dispatch);
    // let vTruckArr = await GetTruck(dispatch);

    let vDocLoadingArr = iAttributeResp.DocLoading;
    let icurrentDocLoading = {
      VocTyp: "",
      VocName: "",
      Paymode: "",
    };
    if (vDocLoadingArr.length > 0) {
      // setDocLoading(vDocLoadingArr);
      icurrentDocLoading = vDocLoadingArr[0];
    }
    let vClusterArr = iAttributeResp.Cluster;
    let icurrentCluster = {
      UId: "",
      Name1: "",
    };
    if (vClusterArr.length > 0) {
      // setClusterArr(vClusterArr);
      icurrentCluster = vClusterArr[0];
    }
    let vLocationArr = iAttributeResp.Loaction;
    let icurrentLocation = {
      UID: "",
      Name1: "",
    };
    if (vLocationArr.length > 0) {
      // setLocationArr(vLocationArr);
      console.log("sLocationArr",sLocationArr);
      icurrentLocation = sLocationArr[0];
    }
    let vTransactionArr = iAttributeResp.Transaction;
    let icurrentTransaction = {
      UId: "",
      Name1: "",
    };
    if (vTransactionArr.length > 0) {
      // setTransactionArr(vTransactionArr);
      icurrentTransaction = vTransactionArr[0];
    }
    let vLoadingBayArr = iAttributeResp.Loading_Pay;
    let icurrentLoadingBay = {
      UId: "",
      Name1: "",
    };
    if (vLoadingBayArr.length > 0) {
      // setUnloadingBayArr(vLoadingBayArr);
      icurrentLoadingBay = vLoadingBayArr[0];
    }

    let vTruckArr = iAttributeResp.Truck;
    let icurrentTruck = {
      UId: "",
      Name1: "",
      Driver: "",
      DriverName: "",
      CBM: 0,
    };
    if (vTruckArr.length > 0) {
      // setTruckArr(vTruckArr);
      icurrentTruck = vTruckArr[0];
    }

    let vLoadingListCheckboxArr = await GetLoadingListCheckbox(
      vRdxWmsHead?.A_VocTyp == "" ||
        vRdxWmsHead?.A_VocTyp == null ||
        vRdxWmsHead?.A_VocTyp == undefined
        ? icurrentDocLoading.VocTyp
        : vRdxWmsHead.A_VocTyp,
      vRdxWmsHead?.A_VocNo,
      dispatch
    );
    if (vLoadingListCheckboxArr.length > 0) {
      dispatch(
        Set_LoadingList_HeadLoadingListUserCheckbox(vLoadingListCheckboxArr)
      );
    }

    dispatch(
      Set_LoadingList_HeadObject_Set({
        ...vRdxWmsHead,
        A_VocTyp:
          vRdxWmsHead?.A_VocTyp == "" ||
          vRdxWmsHead?.A_VocTyp == null ||
          vRdxWmsHead?.A_VocTyp == undefined
            ? icurrentDocLoading.VocTyp
            : vRdxWmsHead.A_VocTyp,
        A_VocTypName:
          vRdxWmsHead?.A_VocTyp == "" ||
          vRdxWmsHead?.A_VocTyp == null ||
          vRdxWmsHead?.A_VocTyp == undefined
            ? icurrentDocLoading.VocName
            : vRdxWmsHead.A_VocTypName,
        Cluster:
          vRdxWmsHead?.Cluster == "" ||
          vRdxWmsHead?.Cluster == null ||
          vRdxWmsHead?.Cluster == undefined
            ? icurrentCluster.UId
            : vRdxWmsHead.Cluster,
        A_Loc:
          vRdxWmsHead.A_Loc == "" ||
          vRdxWmsHead?.A_Loc == null ||
          vRdxWmsHead?.A_Loc == undefined
            ? icurrentLocation.UID
            : vRdxWmsHead.A_Loc,
        Transaction:
          vRdxWmsHead.Transaction == "" ||
          vRdxWmsHead?.Transaction == null ||
          vRdxWmsHead?.Transaction == undefined
            ? icurrentTransaction.UId
            : vRdxWmsHead.Transaction,
        UnloadingBay:
          vRdxWmsHead.UnloadingBay == "" ||
          vRdxWmsHead?.UnloadingBay == null ||
          vRdxWmsHead?.UnloadingBay == undefined
            ? icurrentLoadingBay.UId
            : vRdxWmsHead.UnloadingBay,
        Truck:
          vRdxWmsHead.Truck == "" ||
          vRdxWmsHead?.Truck == null ||
          vRdxWmsHead?.Truck == undefined
            ? icurrentTruck.UId
            : vRdxWmsHead.Truck,
        A_Type:
          vRdxWmsHead.A_Type == "" ||
          vRdxWmsHead?.A_Type == null ||
          vRdxWmsHead?.A_Type == undefined
            ? sLoadingTypeArr[0]
            : vRdxWmsHead.A_Type,
        TruckCBM:
          vRdxWmsHead.Truck == "" ||
          vRdxWmsHead?.Truck == null ||
          vRdxWmsHead?.Truck == undefined
            ? icurrentTruck.CBM
            : vRdxWmsHead.TruckCBM,
        Driver:
          vRdxWmsHead.Truck == "" ||
          vRdxWmsHead?.Truck == null ||
          vRdxWmsHead?.Truck == undefined
            ? icurrentTruck.Driver
            : vRdxWmsHead.Driver,
        DriverName:
          vRdxWmsHead.Truck == "" ||
          vRdxWmsHead?.Truck == null ||
          vRdxWmsHead?.Truck == undefined
            ? icurrentTruck.DriverName
            : vRdxWmsHead.DriverName,
        A_Party:
          vRdxWmsHead?.A_VocTyp == "" ||
          vRdxWmsHead?.A_VocTyp == null ||
          vRdxWmsHead?.A_VocTyp == undefined
            ? AllPartyFlag()
              ? "ALL"
              : ""
            : vRdxWmsHead.A_Party,
        A_PartyName:
          vRdxWmsHead?.A_VocTyp == "" ||
          vRdxWmsHead?.A_VocTyp == null ||
          vRdxWmsHead?.A_VocTyp == undefined
            ? AllPartyFlag()
              ? "ALL"
              : ""
            : vRdxWmsHead.A_PartyName,
      })
    );

    fLoad_Grid(
      vRdxWmsHead.A_VocNo,
      vRdxWmsHead?.A_VocTyp == "" ||
        vRdxWmsHead?.A_VocTyp == null ||
        vRdxWmsHead?.A_VocTyp == undefined
        ? icurrentDocLoading.VocTyp
        : vRdxWmsHead.A_VocTyp
    );
  }, [dispatch]);

  useEffect(() => {
    onload();
  }, [onload]);

  useEffect(() => {
    var resultObj = fCheck_Doc_Rights_001(
      vRdxWmsHead.A_DocStat,
      vRdxWmsHead.A_VocTyp,
      !!sObjectRights && sObjectRights.length > 0 ? sObjectRights : []
    );
    setObjRights(resultObj);
  }, [vRdxWmsHead.A_DocStat, vRdxWmsHead.A_VocTyp, sObjectRights]);

  const fkeyup = useCallback((e) => {
    if (e.which == 27 || e.key === "Escape") {
      setGC_Toggle_Head_Customer_ToggleDropDowm(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("keyup", (e) => fkeyup(e), false);
    return () => {
      document.removeEventListener("keyup", fkeyup, false);
    };
  }, [fkeyup]);

  const fkeyup2 = useCallback(
    (e) => {
      let vRdxPrint = "WMLDLSTD";
      FShortCutKey(
        e,
        "IdNew",
        "IdSave",
        "IdApprove",
        "IdSearch",
        "IdDelete",
        "IdAudit",
        vRdxPrint,
        fPrint
      );
    },
    [fPrint]
  );

  const GetGitterColumns_LDST = async (
    setSummaryGridColumn,
    xtrnTyp = "",
    xSummary_Grid_ColumnsDummy
  ) => {
    const vGitterColumns = await RpDesign_getGitterColumns_trnTyp_GETROW(
      xtrnTyp
    );
    if (vGitterColumns?.status === 200) {
      if (vGitterColumns?.data?.ResultSet?.columns?.length > 0) {
        let { columns } = vGitterColumns?.data?.ResultSet;
        // columns = await columns.json();
        // return data;
        columns.forEach((obj) => {
          if (obj.Typ === "D") {
            obj.valueFormatter = ({ value }) =>
              moment(value).format(obj.NumberFormat);
          } else if (obj.Typ === "N") {
            obj.valueFormatter = ({ value }) => {
              if (Number(value)?.toFixed(obj.NumberFormat)) {
                Number(value)?.toFixed(obj.NumberFormat);
              } else {
              }
            };
          }
          if (obj.field === "detail") {
            obj.renderCell = (params) => {
              return (
                <Button
                  size="small"
                  color="primary"
                  onClick={() => {
                    fDetailshowModal(params);
                  }}
                >
                  Detail
                </Button>
              );
            };
          } else if (obj.field === "print") {
            obj.renderCell = (params) => {
              return (
                <Button
                  size="small"
                  color="primary"
                  onClick={() => {
                    fPrintshowModal(params);
                  }}
                >
                  Print
                </Button>
              );
            };
          }
        });
        console.log(columns);
        setSummaryGridColumn(columns.filter((x) => x.hide === false));
      } else {
        setSummaryGridColumn(xSummary_Grid_ColumnsDummy);
        // fAlertToast("FAILED", "GitterColumns (" + xtrnTyp + ") is Empty");
      }
    } else {
      setSummaryGridColumn(xSummary_Grid_ColumnsDummy);
    }
  };
  useEffect(() => {
    GetGitterColumns_LDST(
      setGridDataColumnsWmsSiDetail,
      "LOACDINGLIST_LDST",
      GridDataColumnsWmsSiDetail
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [sGridDataAuditColumns, setGridDataAuditColumns] =
    useState(GridDataAuditColumns);
  const [sGridDataColumnsSearch, setGridDataColumnsSearch] = useState(
    GridDataColumnsSearch
  );

  useEffect(() => {
    GetGitterColumns(
      setGridDataAuditColumns,
      "WMS_SALES_INVOICE_AUDIT",
      sGridDataAuditColumns
    );
    GetGitterColumns(
      setGridDataColumnsSearch,
      "LOACDINGLIST_SEARCH",
      sGridDataColumnsSearch
    );
    GetGitterColumns(
      setGridDetailColumnModal,
      "LOACDINGLIST_DTL_BTN",
      sGridDetailColumnModal
    );
    GetGitterColumns(
      setGC_Toggle_Head_Customer_GridColumns,
      "DROPDOWN_CUSTOMER_SEARCH",
      xGC_Toggle_Head_Customer_GridColumns
    );
    GetGitterColumns(
      setGridDataAccountDetailColumns,
      "ACPSTINGDTLTRNS",
      sGridDataAccountDetailColumns
    );
    GetGitterColumns(
      setGridDataLinkDocumentColumns,
      "WMINV08LINKDDOC",
      sGridDataLinkDocumentColumns
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useLayoutEffect(() => {
    window.addEventListener("keyup", fkeyup2);

    return () => {
      window.removeEventListener("keyup", fkeyup2);
    };
  }, [fkeyup2]);
  return (
    <div className="container-fluid">
       <div
      style={{
        position: "fixed",
        top: 45,
        left: 2,
        width: "100%",
        backgroundColor: "white",
        zIndex: 2,
      }}
    >
         <div>
            {/* mobile Screen nav  */}
            <Grid
              container
              spacing={0}
              className="my-2 Wms-inbound-grn-nav-md-hide"
              columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
              sx={{ alignItems: "center" }}
            >
              <Grid
                item
                xs={2.4}
                sm={1}
                md={1}
                lg={1}
                sx={{ justifyContent: "center", textAlign: "center" }}
              >
 
                <CmpButtonKWithIcon
                  xOnClick={fNew}
                  xDisabled={sObjRights.RNew == "N"}
                  xIcon={<AddBoxRoundedIcon fontSize={"small"} />}
                />
              </Grid>
              <Grid
                item
                xs={2.4}
                sm={1}
                md={1}
                lg={1}
                sx={{ justifyContent: "center", textAlign: "center" }}
              >
                 
                <CmpButtonKWithIcon
                  xOnClick={fSave}
                  xDisabled={sObjRights.RSave == "N"}
                  xIcon={<SaveRoundedIcon fontSize={"small"} />}
                  xcolor="success"
                />
              </Grid>
         
              <Grid
                item
                xs={2.4}
                sm={1}
                md={1}
                lg={1}
                sx={{ justifyContent: "center", textAlign: "center" }}

                // className="xs-dontShowInMobileView"
              >
                
                {sObjRights.RApprove == "N"&& false ? (
                  
                  <CmpButtonKWithIcon
                    xOnClick={() => {
                      fApprove("DRAFT");
                    }}
                    xDisabled={vRdxWmsHead.A_DocStat != "ENTER" ? true : false}
                    xIcon={<CheckCircleOutlineRoundedIcon fontSize={"small"} />}
                  />
                ) : (
                  
                  <CmpButtonKWithIcon
                    xOnClick={() => {
                      fApprove("POST");
                    }}
                    xDisabled={
                      vRdxWmsHead.A_DocStat == "ENTER" ||
                      vRdxWmsHead.A_DocStat == "DRAFT"
                        ? false
                        : true
                    }
                    xIcon={<CheckCircleOutlineRoundedIcon fontSize={"small"} />}
                  />
                )}
              </Grid>

              <Grid
                item
                xs={2.4}
                sm={1}
                md={1}
                lg={1}
                sx={{ justifyContent: "center", textAlign: "center" }}
              > 
                  <CmpButtonKWithIcon
                  xOnClick={() => {
                    setShowMore(!sShowMore);
                  }}
                  xDisabled={false}
                  xIcon={
                    sShowMore ? (
                      <KeyboardDoubleArrowRightIcon  fontSize={"small"} />
                    ) : (
                      < KeyboardDoubleArrowDownIcon fontSize={"small"} />
                    )
                  }
                />
              
              </Grid>

              <Grid
                item
                xs={2.4}
                sm={1}
                md={1}
                lg={1}
                sx={{ justifyContent: "center", textAlign: "center" }}
              >
                 
                <CmpButtonKWithIcon
                  xOnClick={fDelete}
                  xDisabled={sObjRights.RDelete == "N" ? true : false}
                  xIcon={<DeleteRoundedIcon fontSize={"small"} />}
                     xcolor="error"
                />
              </Grid>
            </Grid>
           
       {sShowMore &&     <Grid
              container
              spacing={0}
              // sx={{ alignItems: "center", justifyContent: "space-between" }}
              // className="Wms-inbound-grn-nav-md-hide Pre-Next"
              sx={{ alignItems: "center" }}
              className="  Wms-inbound-grn-nav-md-hide mb-2"
            >
              <Grid
                item
                xs={2.4}
                sx={{ justifyContent: "center", textAlign: "center" }}
              >
                <CmpButtonKWithIcon
                  xOnClick={() => {
                    fSearch();
                  }}
                  xDisabled={false}
                  xIcon={<SearchRoundedIcon fontSize={"small"} />}
                />
              </Grid>
              <Grid
                item
                xs={2.4}
                sm={1}
                md={1}
                lg={1}
                sx={{ justifyContent: "center", textAlign: "center" }}
              >
                 
                <CmpButtonKWithIcon
                  xOnClick={() => {
                    fView();
                  }}
                  xDisabled={false}
                  xIcon={<ViewTimelineOutlinedIcon fontSize={"small"} />}
                />
              </Grid>
              <Grid
                item
                xs={2.4}
                sm={12}
                md={1}
                lg={1}
                sx={{ justifyContent: "center", textAlign: "center" }}
              ></Grid>
              <Grid
                item
                xs={2.4}
                sm={12}
                md={1}
                lg={1}
                sx={{ justifyContent: "center", textAlign: "center" }}
              >
                 
                <CmpButtonKWithIcon
                  xOnClick={() => {
                    fSummary();
                  }}
                  xDisabled={false}
                  xIcon={<GridOnOutlinedIcon fontSize={"small"} />}
                />
              </Grid>
              <Grid
                item
                xs={2.4}
                sm={1}
                md={1}
                lg={1}
                sx={{ justifyContent: "center", textAlign: "center" }}
              >
                 
              </Grid>
            </Grid>}
          </div></div>
      <div className="row">
        <div className="col-12">
          <div className="Wms-LoadingList-grv ">
            <Grid
              container
              spacing={0}
              className="my-1 Wms-inbound-grn-nav-sm-hide "
              columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
              sx={{ alignItems: "center" }}
            >
              <Grid item xs={1} sm={2} md={1} lg={1}>
                <CmpButton
                  xbtnName="New"
                  xOnClick={(e) => fNew(0)}
                  xVariant="text"
                  xDisabled={sObjRights.RNew == "N" ? true : false}
                  xSize="small"
                  xId={"IdNew"}
                  xSendIcon={<AddBoxRoundedIcon />}
                />
              </Grid>
              <Grid item xs={1} sm={2.5} md={1} lg={1}>
                <CmpButton
                  xbtnName="Save"
                  xOnClick={fSave}
                  xVariant="text"
                  xDisabled={sObjRights.RSave == "N" ? true : false}
                  xSize="small"
                  xId={"IdSave"}
                  xSendIcon={<SaveRoundedIcon />}
                />
              </Grid>
              <Grid item xs={1} sm={2.5} md={1} lg={1}>
                {sObjRights.RApprove == "N" && false? (
                  <CmpButton
                    xbtnName="Draft"
                    xOnClick={() => {
                      fApprove("DRAFT");
                    }}
                    xVariant="text"
                    // xDisabled={sObjRights.RApprove == "N" ? true : false}
                    xDisabled={vRdxWmsHead.A_DocStat != "ENTER" ? true : false}
                    xSize="small"
                    xId={sObjRights.RApprove == "N" ? "IdApprove" : ""}
                    xSendIcon={<CheckCircleOutlineRoundedIcon />}
                  />
                ) : (
                  <CmpButton
                    xbtnName="Approve"
                    xOnClick={() => {
                      fApprove("POST");
                    }}
                    xVariant="text"
                    // xDisabled={sObjRights.RApprove == "N" ? true : false}
                    xDisabled={
                      vRdxWmsHead.A_DocStat == "ENTER" ||
                      vRdxWmsHead.A_DocStat == "DRAFT"
                        ? false
                        : true
                    }
                    xSize="small"
                    xId={sObjRights.RApprove == "Y" ? "IdApprove" : ""}
                    xSendIcon={<CheckCircleOutlineRoundedIcon />}
                  />
                )}
              </Grid>
              <Grid item xs={1} sm={2.5} md={1} lg={1}>
                <CmpButton
                  xbtnName="Search"
                  xOnClick={fSearch}
                  xVariant="text"
                  xDisabled={false}
                  xSize="small"
                  xId={"IdSearch"}
                  xSendIcon={<SearchRoundedIcon />}
                />
              </Grid>
              <Grid item xs={1} sm={2.5} md={1} lg={1}>
                <CmpButton
                  xbtnName="Delete"
                  xOnClick={fDelete}
                  xVariant="text"
                  xDisabled={sObjRights.RDelete == "N" ? true : false}
                  xSize="small"
                  xId="IdDelete"
                  xSendIcon={<DeleteRoundedIcon />}
                />
              </Grid>
              <Grid item xs={1} sm={2} md={0.5} lg={0.5}>
                <CmpButtonKIcon
                  xOnClick={fMove_First}
                  xDisabled={false}
                  xIcon={<FirstPageIcon fontSize={"small"} />}
                />
              </Grid>
              <Grid
                item
                xs={1}
                sm={2}
                md={0.5}
                lg={0.5}
                className="text-center"
              >
                <CmpButtonKIcon
                  xOnClick={fMove_Previouse}
                  xDisabled={false}
                  xIcon={<ArrowBackIosIcon fontSize={"small"} />}
                />
              </Grid>
              <Grid item xs={1} sm={4} md={1} lg={1} className="text-center">
                {sNavDocValue} of {sUser_Doc_Arr.length}
              </Grid>
              <Grid
                item
                xs={1}
                sm={2}
                md={0.5}
                lg={0.5}
                className="text-center"
              >
                <CmpButtonKIcon
                  xOnClick={fMove_Next}
                  xDisabled={false}
                  xIcon={<ArrowForwardIosIcon fontSize={"small"} />}
                />
              </Grid>
              <Grid
                item
                xs={1}
                sm={2}
                md={0.5}
                lg={0.5}
                className="text-center"
              >
                <CmpButtonKIcon
                  xOnClick={fMove_Last}
                  xDisabled={false}
                  xIcon={<LastPageIcon fontSize={"small"} />}
                />
              </Grid>
              <Grid item xs={1} sm={2} md={1} lg={1}>
                <DropdownButton
                  id="dropdown-basic-button"
                  title="Print"
                  variant="outlined"
                  size="sm"
                  disabled={sObjRights.RPrint == "N" ? true : false}
                >
                  <Dropdown.Item
                    id="PrintId"
                    onClick={(e) => {
                      fPrint("WMLDLSTD");
                    }}
                  >
                    Detail
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={(e) => {
                      fPrint("WMLDLSTC");
                    }}
                  >
                    Consolidated
                  </Dropdown.Item>

                  <Dropdown.Item
                    onClick={(e) => {
                      fPrint("WMLDLSTV");
                    }}
                  >
                    Variance
                  </Dropdown.Item>
                </DropdownButton>
              </Grid>
              <Grid item xs={1} sm={2} md={1} lg={1}>
                <CmpButton
                  xbtnName="Audit"
                  xOnClick={fAudit}
                  xVariant="text"
                  xDisabled={false}
                  xSize="small"
                  xId="IdAudit"
                  xSendIcon={<SendIcon />}
                />
              </Grid>
              {/* <Grid item xs={1} sm={1} md={1.5} lg={1.5}>
                <CmpButton
                  xbtnName="Account Detail"
                  xOnClick={fAccountDetail}
                  xVariant="text"
                  xDisabled={false}
                  xSize="small"
                  xSendIcon={<AccountBalanceOutlinedIcon />}
                />
              </Grid> */}
              <Grid item xs={1} sm={1} md={1.5} lg={1.5}>
                <GCMenuBtn
                  menuLabel="More"
                  menuItems={[
                    { label: "Account Detail", onClick: fAccountDetail },
                    { label: "Updated Truck", onClick: fUpdatedTruck },
                    // { label: "Link Document", onClick: fLinkDocument },
                  ]}
                />
              </Grid>
            </Grid>
          
            <>
              <div id="wms-salese-invoice-id">
                <div className=" wms-incoice-sales-m main-wms-sales-invoice-hide-sm main-wms-sales-invoice-show-sm ">
                  <GCHead
                  vRdxLoadingListUser={vRdxLoadingListUser}
                  dispatch={dispatch}
                    vRdxWmsHead={vRdxWmsHead}
                    fGrnType={fGrnType}
                    sDocLoadingGrnType={sDocLoading}
                    xErrorMsg={sErrorMsg}
                    xDisableBasedOnGridDataLength={false}
                    fGrnDate={fGrnDate}
                    sClusterArr={sClusterArr}
                    fCluster={fCluster}
                    fLocation={fLocation}
                    vRdxuserLoc={sLocationArr}
                    fLoadingType={fLoadingType}
                    sLoadingTypeArr={sLoadingTypeArr}
                    fTransaction={fTransaction}
                    sTransactionArr={sTransactionArr}
                    fTruck={fTruck}
                    sTruckArr={sTruckArr}
                    fUnloadingBay={fUnloadingBay}
                    sUnloadingBayArr={sUnloadingBayArr}
                    fDriver={fDriver}
                    fDriverEnter={fDriverEnter}
                    sLoadingListCheckboxArr={vRdxLoadingListUserCheckbox}
                    fLoadingListCheckBox={fLoadingListCheckBox}
                    fLoad_Release={fLoad_Release}
                    //customer start

                    xGC_Toggle_Head_Customer_DropDown_Arr={
                      xGC_Toggle_Head_Customer_DropDown_Arr
                    } //sub input arr
                    xfGC_Toggle_Head_Customer_Name={
                      xfGC_Toggle_Head_Customer_Name
                    } //onchange main input
                    xGC_Toggle_Head_Customer_Toggle={
                      sGC_Toggle_Head_Customer_ToggleDropDowm
                    } //boolean true  false
                    xGC_Toggle_Head_Customer_onKeyUp={
                      fGC_Toggle_Head_Customer_onKeyUp
                    } //main input enter
                    xGC_Toggle_Head_Customer_SearchDropdownObj={
                      sGC_Toggle_Head_Customer_SearchDropdownObj
                    } //sub input obj
                    xGC_Toggle_Head_Customer_Dropdown_onChange={
                      fGC_Toggle_Head_Customer_Dropdown_onChange
                    } //sub input onchange
                    xGC_Toggle_Head_Customer_Dropdown_OnKeyUp_Load={
                      fGC_Toggle_Head_Customer_Dropdown_OnKeyUp_Load
                    } //sub input load
                    xGC_Toggle_Head_Customer_GridColumns={
                      xGC_Toggle_Head_Customer_GridColumns
                    } //sub input col
                    xGC_Toggle_Head_Customer_GridData={
                      sGC_Toggle_Head_Customer_GridData
                    } //sub input grid
                    xfGC_Toggle_Head_Customer_OnCellKeyDown={
                      fGC_Toggle_Head_Customer_OnCellKeyDown
                    } //sub input row enter
                    xfGC_Toggle_Head_Customer_OnRowClick={
                      fGC_Toggle_Head_Customer_OnRowClick
                    } //sub input row click
                    //customer end
                  />
                   {vMediaQuery && (
                <DetailTblCard
                  data={sDetailGridData}
                  onClick={fDetail_Grid_onRowClick}
                />
              )}
                </div>
                <div className="wms-sales-Content wms-incoice-sales-m main-wms-sales-invoice-hide-sm ">
                  <div className="wms-sales-content-grid xs-screen-hide">
                    <div style={{ height: "55vh", width: "100%" }}>
                      <DataGrid
                        rowHeight={30}
                        headerHeight={40}
                        getRowClassName={(params) =>
                          params.indexRelativeToCurrentPage % 2 === 0
                            ? "mui-even-row"
                            : "mui-odd-row"
                        }
                        sx={{
                          border: 1,
                          borderColor: "primary.light",
                            '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: '#0d73bb',
                    color: 'white'
                  },
                        }}
                        rows={sDetailGridData}
                        columns={GridDataColumnsWmsSiDetail}
                        onRowClick={fDetail_Grid_onRowClick}
                        hideFooter={sDetailGridData.length < 100}
                        checkboxSelection={!sIsSelectedY}
                        onSelectionModelChange={
                          !sIsSelectedY
                            ? handleSelectionChange
                            : DummySelectionChange
                        }
                        selectionModel={!sIsSelectedY ? selectedRows : []}
                        // components={{
                        //   Toolbar: GridToolbar,
                        // }}
                      />
                    </div>
                  </div>
                </div>
                <div className="wms-sales-footer wms-incoice-sales-m main-wms-sales-invoice-hide-sm ">
                  <WmsFooter
                    vRdxWmsHead={vRdxWmsHead}
                    fTruckCBM={fTruckCBM}
                    fItemCBM={fItemCBM}
                    fTotalWeignt={fTotalWeignt}
                    fPrintAllDocument={fPrintAllDocument}
                  />
                </div>
              </div>
            </>
          </div>
        </div>
      </div>
      {/* Audit  */}
      {/* <GCAudit
        xOpen={sAuditModal}
        xTitle={"AUDIT"}
        fCloseAuditModal={fCloseAuditModal}
        sAuditSelectArr={sAuditSelectArr}
        GridDataAuditColumns={sGridDataAuditColumns}
        GridDataAuditRows={sGridDataAuditRows}
        xAuditId={xAuditId}
        fonChangeAuditSelect={fonChangeAuditSelect}
        xLabel={vRdxWmsHead.A_VocTypName + " - " + vRdxWmsHead.A_VocNo}
      /> */}
      <GCAuditTblCard
        xOpen={sAuditModal}
        xLabel={vRdxWmsHead.A_VocTypName + " - " + vRdxWmsHead.A_VocNo}
        fCloseAuditModal={setAuditModal}
        trnTyp={sTransTypeAudit}
        vocTyp={vRdxWmsHead.A_VocTyp}
        vocNo={vRdxWmsHead.A_VocNo}  
      />
      {/* //Grid Detail Btn Modal  */}
      <Modal
        open={sGridDetailModal}
        onClose={fCloseGridDetailModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
         
          <GCTitleSticky title={'Grid'} onClose={fCloseGridDetailModal} />
       
          <div className="p-3">
            <div style={{ height: 600, width: "100%" }}>
              <DataGrid
                rowHeight={30}
                headerHeight={40}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0
                    ? "mui-even-row"
                    : "mui-odd-row"
                }
                sx={{
                  border: 1,
                  borderColor: "primary.light",
                }}
                rows={sGridDetailRowModal}
                columns={sGridDetailColumnModal}
                hideFooter={sGridDetailRowModal.length < 100}
                components={{
                  Toolbar: GridToolbar,
                }}
              />
            </div>
          </div>
        </Box>
      </Modal>
      {/* //View Modal  */}
      <Modal
        open={sViewModal}
        onClose={fCloseViewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
        <GCTitleSticky title={"Detail"} onClose={fCloseViewModal} />
        <div className="p-2">
        <div style={{ height: "70vh", width: "100%" }}>
            <DataGrid
              rowHeight={30}
              headerHeight={40}
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0
                  ? "mui-even-row"
                  : "mui-odd-row"
              }
              sx={{
                border: 1,
                borderColor: "primary.light",
              }}
              rows={sDetailGridData}
              columns={GridDataColumnsWmsSiDetail}
              onRowClick={fDetail_Grid_onRowClick}
              hideFooter={sDetailGridData.length < 100}
              components={{
                Toolbar: vMediaQuery ? "" : GridToolbar,
              }}
            />
          </div>
        </div>
          
        </Box>
      </Modal>
      {/* summary  */}
      <Modal
        open={sSummaryModal}
        onClose={fCloseSummaryModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance ">
          <GCTitleSticky title={"Summary "} onClose={fCloseSummaryModal} />
          <div className="p-2">
          <WmsFooter vRdxWmsHead={vRdxWmsHead} />

          </div>
        </Box>
      </Modal>
      {/* Search  */}
      <GCLoadingListSearch
        open={sSearchModal}
        xStatusArr={sStatusArr}
        xLocationArr={sSearchLoactionArr}
        fonChangeStatusModal={fonChangeStatusModal}
        fonChangeVocNoModal={fonChangeVocNoModal}
        fOnChangeDateModel={fOnChangeDateModel}
        fonChangeLocModal={fonChangeLocModal}
        fonChangeRefNoModal={fonChangeRefNoModal}
        xGetSearchValue={GetSearchValue}
        fCloseSearchModal={fCloseSearchModal}
        fClearSearchModal={fClearSearchModal}
        GridSearchHeadRowData={sGridSearchHeadRowData}
        GridDataColumnsSearch={sGridDataColumnsSearch}
        xOnCellKeyDownSearch={(newSelectionModel, e) => {
          if (e.key === "Enter") {
            fTrans_Search_Grid_RowClick(newSelectionModel);
          }
        }}
        xOnRowClickSearch={fTrans_Search_Grid_RowClick}
        vMediaQuery={vMediaQuery}
        xEnterObj={sEnterKeyObj}
        xTitle={"Loading List - Search"}
        xStatusVal={sSearchModalObj.Status}
        xVocNoVal={sSearchModalObj.VocNo}
        xPostDtVal={sSearchModalObj.PostDt}
        xLocVal={sSearchModalObj.Loc}
        xRefNoVal={sSearchModalObj.RefNo}
      />
      {/* Reverse Narration  */}
      <GCReverse
        open={sReverseTransactionModal}
        fCloseReverseTransactionModal={fCloseReverseTransactionModal}
        sRevNarr={sRevNarr}
        setRevNarr={setRevNarr}
        fReverse={fReverse}
      />
      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />

      <GCAccountDetail
        xOpen={sAccountDetailModal}
        fCloseDetailModal={fCloseAccountDetailModal}
        GridDataAccountDetailColumns={sGridDataAccountDetailColumns}
        GridDataAccountDetailRows={sGridDataAccountDetailRows}
        xTitle={"Account Detail"}
        xLabelVocType={vRdxWmsHead.A_VocTyp}
        xLabelVocName={vRdxWmsHead.A_VocTypName}
        xLabelVocNo={vRdxWmsHead.A_VocNo}
      />

      <UpdatedTruck
        xOpen ={updatedTruck}
        CloseUpdatedTruckModal={CloseUpdatedTruckModal}
        vRdxWmsHead={vRdxWmsHead}
        xTitle = "Updated Truck"
        fNewDetail={fNewDetail}
        dispatch={dispatch}
        sTruckArr={sTruckArr}
      />

      <GCLinkDocument
        xOpen={sLinkDocumentModal}
        fCloseDetailModal={fCloseLinkDocumentModal}
        GridDataLinkDocumentColumns={sGridDataLinkDocumentColumns}
        GridDataLinkDocumentRows={sGridDataLinkDocumentRows}
        xTitle={"Link Document"}
        xLabelVocType={vRdxWmsHead.A_VocTyp}
        xLabelVocName={vRdxWmsHead.A_VocTypName}
        xLabelVocNo={vRdxWmsHead.A_VocNo}
      />
    </div>
  );
}
